import { ExcelTemplateTypes, ItemFloatTemplateSearchTypes } from "enums";
import { useInOutTransition } from "hooks";
import SearchRadioInput from "./SearchRadioInput";

interface Props {
    searchType: string,
    updateHandler: (x: ItemFloatTemplateSearchTypes) => void,
    selectedTemplateType: ExcelTemplateTypes
}

export default function ItemFloatTemplateSearchOptions(props: Props) {
    const { searchType, updateHandler, selectedTemplateType } = props,
          shouldRender = selectedTemplateType === ExcelTemplateTypes.FloatItem,
          { isActive, isNotTransitionedOut } = useInOutTransition(shouldRender, 0, 275);
    return (isNotTransitionedOut && 
        <>
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="customerId" 
                              labelText="Customer ID"
                              checkedCondition={searchType === ItemFloatTemplateSearchTypes.CustomerId}
                              onClick={() => updateHandler(ItemFloatTemplateSearchTypes.CustomerId)} />
            
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="customerName" 
                              labelText="Customer Name" 
                              checkedCondition={searchType === ItemFloatTemplateSearchTypes.CustomerName}
                              onClick={() => updateHandler(ItemFloatTemplateSearchTypes.CustomerName)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="itemNumber" 
                              labelText="Item Number" 
                              checkedCondition={searchType === ItemFloatTemplateSearchTypes.ItemNumber}
                              onClick={() => updateHandler(ItemFloatTemplateSearchTypes.ItemNumber)} />
            
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="contractNumber" 
                              labelText="Contract Number" 
                              checkedCondition={searchType === ItemFloatTemplateSearchTypes.ContractNumber}
                              onClick={() => updateHandler(ItemFloatTemplateSearchTypes.ContractNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="contractName" 
                              labelText="Contract Name" 
                              checkedCondition={searchType === ItemFloatTemplateSearchTypes.ContractName}
                              onClick={() => updateHandler(ItemFloatTemplateSearchTypes.ContractName)} />
        </>
    );
}
